;
define("cart_summary.tpl", function(){});

